import {
  BirthDay,
  Cancel,
  Favourite,
  Message,
  PicCount,
  PremiumIcon,
  ProfileId,
  ThreeDotMenu,
  UserHeight,
  WhiteTick,
} from "assets/icons";
import Tag from "BaseWidgets/tag";
import Button from "components/BaseWidgets/button";
import ImageSlide from "components/BaseWidgets/imageSlider";
import VerificationBadgeModal from "components/CustomWidgets/verificationBadgeModal";
import React, { useState } from "react";
import "./style.scss";
import AlertNotification from "components/CustomWidgets/alertNotification";
import { profileVerification } from "utils/profileVerification";
import { DeleteIconCircle } from "assets/icons";
import ActionModal from "components/Settings/components/ActionModal";
import {
  useAlbumRequestHandler,
  // useContactRequestHandler,
  useInterestRequestHandler,
  useMarkFavourite,
  useMarkNoInterested,
  useRequestAlbum,
  useSendInterest,
} from "hooks/api/useHome";
import { useQueryClient } from "@tanstack/react-query";
import NotInterestedModal from "./components/NotInterestedModal";
import FemaleEmptyState from "assets/images/png/empty-female.png";
import MaleEmptyState from "assets/images/png/empty-male.png";
import { retrieveToken } from "utils/storage";
import { displayTextOrDash, normalizeText } from "utils/formatHelper";
import Dropdown from "components/BaseWidgets/dropdown";
import { useRemoveFromProfile } from "hooks/api/useEngage";
import { useBlockProfile, useReportProfile } from "hooks/api/useOnboard";
import ShareModal from "components/CustomWidgets/shareModal";
import ReportProfileModal from "./components/ReportProfileModal";
import { useNavigate, useLocation } from "react-router-dom";
import Tooltip from "components/BaseWidgets/toolTip";
import { db } from "../../../firebase/firebaseChat"; // adjust this path if needed
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  serverTimestamp,
  setDoc,
  doc,
  increment,
  getDoc,
} from "firebase/firestore";
import { useSendMessage } from "hooks/api/useSendMessage";
import { usePremium } from "context/PremiumContext";
import GoPremiumModal from "components/CustomWidgets/goPremiumModal";
import { sendMessageApi } from "api/sendMessageApi";
import { VERIFICATION_TYPE } from "components/MyProfile/helper";

const ProfileCard = ({
  snippetProfileId,
  profileImage,
  userName,
  religion,
  imageCount,
  profession,
  lastSeen,
  maritalStatus,
  livesIn,
  primaryLanguage,
  createdBy,
  userHeight,
  profileId,
  userAge,
  verificationType,
  isPremium,
  wrapperClass,
  isFavorite,
  isInterested,
  isNotInterested,
  isImageRequested,
  isPrivate,
  shareUrl,
  contactReqByMe,
  contactReqByOthers,
  photoReqByMe,
  photoReqByOthers,
  aec_id,
  InterestReqByOthers,
  cardClassName,
  profiile,
  redirect = true,
  ActionChange = () => [],
  preview = false,
  tabActive,
  selectedList,
  activeTab,
  secondaryTabActive,
}) => {
  console.log(photoReqByMe, "photoReqByMe");

  const [isNotInterestedModalOpen, setIsNotInterestedModalOpen] =
    useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const userData = JSON.parse(retrieveToken("user") || "{}");
  const isMale = normalizeText(userData?.gender) === "male";
  const { isPremium: isUserPremium } = usePremium();
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  let idDescription = "ID verification not completed yet.";
  let physicalDescription = "Physical verification not completed yet.";

  if (
    verificationType === VERIFICATION_TYPE.ID_VERIFIED ||
    verificationType === VERIFICATION_TYPE.BOTH_VERIFIED
  ) {
    idDescription = `We have verified ${userName}’s ID.`;
  }

  if (
    verificationType === VERIFICATION_TYPE.PHYSICAL_VERIFIED ||
    verificationType === VERIFICATION_TYPE.BOTH_VERIFIED
  ) {
    physicalDescription =
      "This profile has been physically verified, ensuring authenticity and trust for a secure matchmaking experience.";
  }

  const defaultImage = preview
    ? isMale
      ? MaleEmptyState
      : FemaleEmptyState
    : isMale
      ? FemaleEmptyState
      : MaleEmptyState;

  const queryClient = useQueryClient();

  const { mutateAsync: sendMessage } = useSendMessage();

  const handleStartChat = async () => {
    const user = JSON.parse(retrieveToken("user") || "{}");
    const currentUserId = user?.aec_id;
    const messageText = `Hi, I am ${currentUserId}, I liked your profile and have sent you a connect request.`;
    const sorted = [currentUserId, profileId].sort();

    const generatedChatId = `${sorted[0]}_${sorted[1]}`;

    try {
      /** 1️⃣ SEND TO BACKEND */
      const apiResponse = await sendMessage({
        id: aec_id, // receiver AEC ID
        message: messageText, // actual text
      });

      // console.log("API returned:", apiResponse);

      /** 2️⃣ WRITE TO FIRESTORE */
      const chatRef = doc(db, "chats", generatedChatId);

      await setDoc(
        chatRef,
        {
          lastMessage: messageText,
          lastMessageSender: currentUserId,
          lastMessageType: "text",
          lastMessageTime: serverTimestamp(),
        },
        { merge: true },
      );

      await addDoc(collection(chatRef, "messages"), {
        senderId: currentUserId,
        receiverId: profileId,
        messageId: Date.now().toString(),
        text: messageText,
        type: "text",
        isDeleted: false,
        mediaUrl: null,
        status: "unread",
        timestamp: serverTimestamp(),
      });
    } catch (error) {
      console.error("❌ Error sending:", error);
    } finally {
      navigate("/connect/chats", {
        state: { chatId: generatedChatId, profileId },
      });
    }
  };

  // const handleStartChat = async () => {
  //   try {
  //     const user = JSON.parse(retrieveToken("user") || "{}");
  //     const currentUserId = user?.aec_id;
  //     const otherUserId = profileId;

  //     if (!currentUserId || !otherUserId) {
  //       AlertNotification("error", "User data not found.");
  //       return;
  //     }

  //     const messageText = `Hi, I am ${currentUserId}, I liked your profile and have sent you a connect request.`;

  //     // 1️⃣ Generate consistent chatId
  //     const sorted = [currentUserId, otherUserId].sort();
  //     const generatedChatId = `${sorted[0]}_${sorted[1]}`;

  //     const chatDocRef = doc(db, "chats", generatedChatId);
  //     const chatSnap = await getDoc(chatDocRef); // 2️⃣ Check if chat already exists

  //     console.log(generatedChatId, "generatedChatId");

  //     if (!chatSnap.exists()) {
  //       await setDoc(chatDocRef, {
  //         chatId: generatedChatId,
  //         users: [currentUserId, otherUserId],
  //         participants: {
  //           [currentUserId]: {
  //             name: user?.full_name || "You",
  //             image: user?.profile_image,
  //           },
  //           [otherUserId]: {
  //             name: userName || "Unknown",
  //             image: profileImage?.[0]?.image || "",
  //           },
  //         },
  //         typingStatus: {
  //           [currentUserId]: false,
  //           [otherUserId]: false,
  //         },
  //         onlineStatus: {
  //           [currentUserId]: false,
  //           [otherUserId]: false,
  //         },
  //         unreadMessageCount: {
  //           [currentUserId]: 0,
  //           [otherUserId]: 0,
  //         },
  //         req_accepted: false,
  //         isActive: true,
  //         createdAt: serverTimestamp(),
  //       });
  //     }

  //     // 4️⃣ Update chat document with last message
  //     await setDoc(
  //       chatDocRef,
  //       {
  //         lastMessage: messageText,
  //         lastMessageSender: currentUserId,
  //         lastMessageType: "text",
  //         lastMessageTime: serverTimestamp(),
  //         [`unreadMessageCount.${otherUserId}`]: increment(1),
  //       },
  //       { merge: true }
  //     );

  //     // 5️⃣ Add message to messages subcollection
  //     await addDoc(collection(chatDocRef, "messages"), {
  //       senderId: currentUserId,
  //       receiverId: otherUserId,
  //       messageId: Date.now().toString(),
  //       text: messageText,
  //       type: "text",
  //       isDeleted: false,
  //       mediaUrl: null,
  //       status: "unread",
  //       timestamp: serverTimestamp(),
  //     });

  //     // 4️⃣ Send first message to your backend API
  //     await sendMessage({
  //       id: aec_id,
  //       message: `Hi, I am ${currentUserId} i liked your profile and have sent you a connect request.`,
  //       file: null,
  //     });

  //     // 6️⃣ Navigate to chat UI
  //     // navigate("/connect/chats", {
  //     //   state: { chatId: firestoreChatId, profileId },
  //     // });
  //   } catch (error) {
  //     console.error("Chat creation/send error:", error);
  //     AlertNotification("error", "Unable to start chat. Please try again.");
  //   }
  // };

  const menuItems = [
    {
      key: "share",
      label: "Share this Profile",
      onClick: () => setIsShareModalOpen(true),
      disabled: preview,
    },
    {
      key: "block",
      label: "Block this Profile",
      onClick: () => setIsBlockModalOpen(true),
      disabled: preview,
    },
    {
      key: "report",
      label: "Report this Profile",
      onClick: () => setIsReportModalOpen(true),
      disabled: preview,
    },
  ];

  const invalidateProfileCache = () => {
    queryClient.invalidateQueries({ queryKey: ["premiumMatches"] });
    queryClient.invalidateQueries({ queryKey: ["recentlyViewed"] });
    queryClient.invalidateQueries({ queryKey: ["careerMatches"] });
    queryClient.invalidateQueries({ queryKey: ["professionalMatches"] });
    queryClient.invalidateQueries({ queryKey: ["profileMayLike"] });
    queryClient.invalidateQueries({ queryKey: ["recommendedProfiles"] });
    queryClient.invalidateQueries({ queryKey: ["latestProfiles"] });
    queryClient.invalidateQueries({ queryKey: ["nearMeMatches"] });
    queryClient.invalidateQueries({ queryKey: ["myMatches"] });
    queryClient.invalidateQueries({ queryKey: ["profileVisited"] });
    queryClient.invalidateQueries({ queryKey: ["profileInterested"] });
    queryClient.invalidateQueries({ queryKey: ["contactRequest"] });
    queryClient.invalidateQueries({ queryKey: ["imageRequest"] });
    queryClient.invalidateQueries({ queryKey: ["favorites"] });
    queryClient.invalidateQueries({ queryKey: ["my-profile"] });
    queryClient.invalidateQueries({ queryKey: ["profile-completion"] });
    queryClient.invalidateQueries({ queryKey: ["searchProfiles"] });
  };

  const { mutate: reportProfileMutate } = useReportProfile({
    onSuccess: () => {
      invalidateProfileCache();
      ActionChange("", snippetProfileId, "remove");
      if (!redirect) {
        navigate(-1);
      }
    },
  });

  const { mutate: blockProfileMutate } = useBlockProfile({
    onSuccess: () => {
      invalidateProfileCache();
      ActionChange("", snippetProfileId, "remove");
      if (!redirect) {
        navigate(-1);
      }
    },
  });

  const { mutate: requestAlbumMutate } = useRequestAlbum({
    onSuccess: () => {
      invalidateProfileCache();
      ActionChange("image_requested", snippetProfileId);
    },
  });

  const { mutate: sendInterestMutate } = useSendInterest({
    onSuccess: () => {
      invalidateProfileCache();
      ActionChange("has_expressed_interest", snippetProfileId);
      queryClient.invalidateQueries({ queryKey: ["profileInterestedCount"] });
    },
  });

  const { mutate: markFavouriteMutate } = useMarkFavourite({
    onSuccess: () => {
      invalidateProfileCache();
      ActionChange("has_favorited", snippetProfileId);
    },
  });

  const { mutate: markNoInterestMutate } = useMarkNoInterested({
    onSuccess: () => {
      invalidateProfileCache();
      ActionChange("", snippetProfileId, "remove");
    },
  });

  const { mutate: removeProfile } = useRemoveFromProfile({
    onSuccess: () => {
      setRemoveModal(false);
      invalidateProfileCache();
    },
  });

  // const { mutate: contactRequestHandler } = useContactRequestHandler({
  //   onSuccess: () => {
  //     invalidateProfileCache();
  //   },
  // });

  const { mutate: albumRequestHandler } = useAlbumRequestHandler({
    onSuccess: () => {
      invalidateProfileCache();
      ActionChange("image_requested", snippetProfileId);
      queryClient.invalidateQueries({ queryKey: ["imageRequestCount"] });
    },
  });

  const { mutate: interestRequestHandler } = useInterestRequestHandler({
    onSuccess: () => {
      invalidateProfileCache();
      ActionChange("has_expressed_interest", snippetProfileId);
      queryClient.invalidateQueries({ queryKey: ["profileInterestedCount"] });
    },
  });

  const [openModal, setOpenModal] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  let imageList = [];

  if (Array.isArray(profileImage) && profileImage.length > 0) {
    imageList = profileImage.map((img) =>
      typeof img === "string" ? img : img?.image,
    );
  } else if (typeof profileImage === "string") {
    imageList = [profileImage];
  } else if (profileImage?.image) {
    imageList = [profileImage.image];
  } else {
    imageList = [defaultImage];
  }

  const isDefault = imageList.length === 1 && imageList[0] === defaultImage;

  const infoItems = [
    { icon: <BirthDay />, label: `${userAge} years` },
    { icon: <ProfileId />, label: `ID: ${profileId}` },
    { icon: <UserHeight />, label: userHeight },
  ];

  const bioItems = [
    { title: "Religion", value: displayTextOrDash(religion) },
    { title: "Profession", value: displayTextOrDash(profession) },
    { title: "Marital status", value: displayTextOrDash(maritalStatus) },
    { title: "Lives in", value: displayTextOrDash(livesIn) },
    { title: "Primary Language", value: displayTextOrDash(primaryLanguage) },
    { title: "Created for", value: displayTextOrDash(createdBy) },
  ];

  const [selected, setSelected] = useState(false);

  return (
    <>
      <div
        className={`user-profile-card ${wrapperClass ? wrapperClass : ""} ${cardClassName}`}
      >
        <div
          className={`profile-image-area ${isPremium ? "gradient-border" : "border"}`}
        >
          <div
            className={`image-blur-wrapper`}
            onContextMenu={(e) => {
              e.preventDefault();
              e.stopPropagation();
              alert("Saving images is disabled for privacy reasons.");
            }}
          >
            {isDefault ? (
              <img src={defaultImage} alt="default" />
            ) : (
              <ImageSlide imageList={imageList} />
            )}
          </div>
          {(isPrivate ||
            contactReqByMe ||
            contactReqByOthers ||
            photoReqByMe ||
            photoReqByOthers) && (
            <div
              className="request-overlay"
              onClick={() => {
                if (redirect) {
                  navigate(`/person-profile/${aec_id}`);
                }
              }}
            >
              {contactReqByOthers ? (
                <div className="flex flex-col gap-2">
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      const payload = {
                        id: snippetProfileId,
                        status: 2,
                        // status = 2:Accepted , 3:Rejected , 4:Cancelled
                      };
                      // if (contactReqByOthers) {
                      //   contactRequestHandler(payload);
                      //   return;
                      // }
                      albumRequestHandler(payload);
                    }}
                    className="request-btn"
                    variant="request"
                    wFull
                  >
                    Approve
                  </Button>
                  <Button
                    height={37}
                    onClick={(e) => {
                      e.stopPropagation();
                      // if (contactReqByOthers) {
                      //   const payload = {
                      //     id: snippetProfileId,
                      //     status: 3,
                      //     // status = 2:Accepted , 3:Rejected , 4:Cancelled
                      //   };
                      //   contactRequestHandler(payload);
                      //   return;
                      // }
                      const payload = {
                        id: snippetProfileId,
                        status: 3,
                        // status = 2:Accepted , 3:Rejected , 4:Cancelled
                      };
                      albumRequestHandler(payload);
                    }}
                    className="request-btn"
                    variant="secondary"
                    wFull
                  >
                    Reject
                  </Button>
                </div>
              ) : (
                !contactReqByMe && (() => {
                  // Hide cancel button in Accepted/Rejected tabs for "Requests by me"
                  const isImageRequestTab = tabActive === "4";
                  const isRequestsByMeAccepted = activeTab === "1" && secondaryTabActive === "2";
                  const isRequestsByMeRejected = activeTab === "1" && secondaryTabActive === "3";
                  const shouldHideCancelButton = isImageRequestTab && (isRequestsByMeAccepted || isRequestsByMeRejected);
                  
                  if (shouldHideCancelButton && photoReqByMe) {
                    return null;
                  }
                  
                  return (
                  <Button
                    variant="request"
                    className="request-photo-btn"
                    isDisabled={
                      contactReqByMe || photoReqByMe ? false : isImageRequested
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      if (preview) return;
                      // if (contactReqByMe) {
                      //   const payload = { id: snippetProfileId, status: 4 };
                      //   contactRequestHandler(payload);
                      //   return;
                      // }
                      if (photoReqByMe) {
                        const payload = { id: snippetProfileId, status: 4 };
                        albumRequestHandler(payload);
                        return;
                      }
                      requestAlbumMutate({
                        id: snippetProfileId,
                        name: userName,
                      });
                    }}
                  >
                    {contactReqByMe || photoReqByMe
                      ? "Cancel request"
                      : isImageRequested
                        ? "Requested"
                        : "Request Photo"}
                  </Button>
                  );
                })()
              )}
            </div>
          )}
          <div className="profile-actions">
            {/* {[<Favourite />, <Message />].map((Icon, i) => (
              <div key={i} className="profile-update backdrop">
                {React.cloneElement(Icon, { style: { stroke: "white" } })}
              </div>
            ))} */}
            <Tag
              className="img-tag"
              isActive={selected}
              onClick={() => setSelected(!selected)}
            >
              {imageCount}
              <span className="pic-icon">
                <PicCount />
              </span>
            </Tag>
          </div>
          {isPremium && (
            <div className="profile-premium">
              <PremiumIcon fill="white" stroke="white" />
            </div>
          )}
        </div>

        <div
          onClick={() => {
            if (redirect) {
              const scrollKey = `scroll-${location.pathname}-tab-${tabActive}`;
              sessionStorage.setItem(scrollKey, window.scrollY.toString());
              sessionStorage.setItem("profileListPath", location.pathname);
              sessionStorage.setItem("exploreActiveTab", tabActive);

              const isEngage = location.pathname.includes("/engage");
              if (isEngage) {
                sessionStorage.setItem("engageActiveTab", tabActive);
                sessionStorage.setItem("engageSubTab", activeTab || "");
                sessionStorage.setItem(
                  "engageSecondaryTab",
                  secondaryTabActive || "",
                );
              }

              if (selectedList) {
                sessionStorage.setItem(
                  "exploreSelectedList",
                  selectedList.toString(),
                );
              }

              navigate(`/person-profile/${aec_id}`, {
                state: { fromProfileDetail: true },
              });
            }
          }}
          className="profile-info pointer"
        >
          <div className="flex justify-between">
            <div className="initial-data">
              <h4 className="font-title-normal user-name">{userName}</h4>
              {verificationType > 0 && (
                <span className="verification-badge" onClick={handleOpenModal}>
                  {profileVerification(verificationType)}
                </span>
              )}
              <Tag
                readOnly
                className="font-body-normal"
                isActive={selected}
                onClick={() => setSelected(!selected)}
              >
                Last seen: {displayTextOrDash(lastSeen)}
              </Tag>
            </div>
            <div className="menu-wrapper" onClick={(e) => e.stopPropagation()}>
              <span className="three-dot-menu">
                <Dropdown
                  items={menuItems}
                  trigger={["click"]}
                  label={<ThreeDotMenu />}
                />
              </span>
            </div>
          </div>

          <div className="user-stats gap-2">
            {infoItems.map(({ icon, label }, i) => (
              <div key={i} className="base-info">
                {icon}
                <p className="font-body-normal">{label}</p>
              </div>
            ))}
          </div>

          <div className="user-bio">
            {bioItems.map(({ title, value }, i) => (
              <div key={i} className="user-card">
                <h3 className="font-body-normal grey-shade">{title}</h3>
                <p className="font-body-lg">{value}</p>
              </div>
            ))}
          </div>

          {isNotInterested || InterestReqByOthers ? (
            <div className="profile-actions flex-wrap">
              <Button
                className="interest-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  const payload = {
                    id: snippetProfileId,
                    status: 2,
                    // status = 2:Accepted , 3:Rejected , 4:Cancelled
                  };
                  if (InterestReqByOthers) {
                    interestRequestHandler(payload);
                    return;
                  }
                  setRemoveModal(true);
                }}
              >
                {InterestReqByOthers ? (
                  "Accept request"
                ) : (
                  <>
                    <Cancel stroke="white" />
                    Remove
                  </>
                )}
              </Button>
              <Button
                variant="tertiary"
                onClick={(e) => {
                  e.stopPropagation();
                  const payload = {
                    id: snippetProfileId,
                    status: 3,
                    // status = 2:Accepted , 3:Rejected , 4:Cancelled
                  };
                  if (InterestReqByOthers) {
                    interestRequestHandler(payload);
                    return;
                  }
                  sendInterestMutate({ id: snippetProfileId });
                }}
              >
                {InterestReqByOthers ? (
                  "Reject request"
                ) : (
                  <>
                    <WhiteTick stroke="#4D4C4D" />
                    Interested
                  </>
                )}
              </Button>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/connect");

                  // if (preview) return;
                  // handleStartChat();
                }}
                variant="tertiary"
              >
                <Message />
                Message
              </Button>
              {!InterestReqByOthers && (
                <Tooltip title="Favourites">
                  <Button
                    variant="round"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isFavorite) {
                        AlertNotification("error", "Removed from favourites");
                      } else {
                        AlertNotification("success", "Added to favourites");
                      }
                    }}
                  >
                    <Favourite
                      fill={isFavorite ? "#AA1538" : "none"}
                      stroke={isFavorite ? "#AA1538" : "currentColor"}
                    />
                  </Button>
                </Tooltip>
              )}
            </div>
          ) : (
            <div className="profile-actions flex-wrap">
              <Button
                className="interest-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  if (preview) return;
                  const payload = {
                    id: snippetProfileId,
                    status: 4,
                    // status = 2:Accepted , 3:Rejected , 4:Cancelled
                  };
                  if (isInterested) {
                    interestRequestHandler(payload);
                    return;
                  }
                  sendInterestMutate({ id: snippetProfileId });
                }}
              >
                {isInterested ? <Cancel stroke="white" /> : <WhiteTick />}
                {isInterested ? "Remove Interest" : "Send Interest"}
              </Button>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  if (preview) return;

                  if (!isUserPremium) {
                    setShowPremiumModal(true);
                    return;
                  }

                  handleStartChat();
                }}
                variant="tertiary"
                // href={"/connect"}
                isDisabled={preview}
              >
                <Message />
                Message
              </Button>
              <Button
                variant="tertiary"
                onClick={(e) => {
                  e.stopPropagation();
                  if (preview) return;
                  setIsNotInterestedModalOpen(true);
                }}
              >
                <Cancel />
                Not Interested
              </Button>
              <Tooltip title="Favourites">
                <Button
                  variant="round"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (preview) return;
                    markFavouriteMutate({ id: snippetProfileId });
                  }}
                >
                  <Favourite
                    fill={isFavorite ? "#AA1538" : "none"}
                    stroke={isFavorite ? "#AA1538" : "currentColor"}
                  />
                </Button>
              </Tooltip>
            </div>
          )}
        </div>
      </div>
      <VerificationBadgeModal
        open={openModal}
        onCancel={handleCancel}
        idDescription={idDescription}
        physicalDescription={physicalDescription}
      />
      <ActionModal
        title="Remove account"
        description={
          <>
            Are you sure to remove <span className="fw-700">{userName}</span>
          </>
        }
        open={removeModal}
        setOpen={setRemoveModal}
        footer={{
          left: { label: "Cancel", action: () => setRemoveModal(false) },
          right: {
            label: "Confirm",
            action: () => removeProfile({ id: snippetProfileId }),
          },
        }}
        icon={<DeleteIconCircle />}
      />
      <NotInterestedModal
        isOpen={isNotInterestedModalOpen}
        onCancel={() => setIsNotInterestedModalOpen(false)}
        onConfirm={() => {
          markNoInterestMutate({ id: snippetProfileId });
          setIsNotInterestedModalOpen(false);
        }}
        title="Are you sure?"
        description={
          <>
            Mark <span className="fw-700">{userName}</span> as{" "}
            <span className="fw-700">"Not Interested"</span>?
          </>
        }
        confirmText="Confirm"
      />
      <NotInterestedModal
        isOpen={isBlockModalOpen}
        onCancel={() => setIsBlockModalOpen(false)}
        onConfirm={() => {
          blockProfileMutate({
            user_id: snippetProfileId,
            reason: "Inappropriate content",
          });
          setIsBlockModalOpen(false);
        }}
        title="Block this Profile"
        description={
          <>
            once blocked, this person will not be able to contact you or view
            your profile
          </>
        }
        confirmText="Block"
        confirmVariant="danger"
      />
      <ReportProfileModal
        isOpen={isReportModalOpen}
        onCancel={() => setIsReportModalOpen(false)}
        onConfirm={(selectedReason) => {
          reportProfileMutate(
            {
              reported_user_id: snippetProfileId,
              reason: selectedReason,
            },
            {
              onSuccess: () => {
                setIsReportModalOpen(false);
              },
            },
          );
        }}
      />
      <ShareModal
        open={isShareModalOpen}
        onCancel={() => setIsShareModalOpen(false)}
        defaultLink={shareUrl || "https://www./profile/3SFYVmsYTIDUfnIs"}
      />
      {showPremiumModal && (
        <GoPremiumModal
          open={showPremiumModal}
          wrapClassName="go-premium-primary"
          contentTitle="Upgrade to send messages"
          buttonTitle="Upgrade plan"
          onCancel={() => setShowPremiumModal(false)}
          onOk={() => setShowPremiumModal(false)}
        />
      )}
    </>
  );
};

export default ProfileCard;
